import styled from 'styled-components';

import { Color } from '@/core/interfaces/common';

import { backgroundVariant } from '@/utils/backgroundVariant';

import { Caption } from '../Typography';

type StyledChipProps = {
  $color: Color;
};

export const StyledChip = styled.div<StyledChipProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  border-radius: 31px;
  padding: 0 8px;
  gap: 4px;
  ${backgroundVariant}
  ${Caption};
`;
